import { useQuery } from '@tanstack/react-query';
import { channelsApi } from '@/api/channels';
import type { ChannelRole } from '@/types';

/**
 * Fetches the current user's role inside a given channel via the existing
 * channelsApi.get(channelId) endpoint, which returns members[0] scoped to the
 * caller. Returns null until loaded.
 */
export function useChannelRole(channelId: string | null | undefined): ChannelRole | null {
  const { data } = useQuery({
    queryKey: ['channel', channelId],
    queryFn: () => channelsApi.get(channelId!),
    enabled: !!channelId,
  });
  return (data?.members?.[0]?.role as ChannelRole | undefined) ?? null;
}

export function canModerate(role: ChannelRole | null): boolean {
  return role === 'OWNER' || role === 'ADMIN' || role === 'MODERATOR';
}
